// @flow
import axios from "axios";
import { toCamelCase } from "@justpark/helpers/src/caseConverter/caseConverter";
import setResponseCookies from "./interceptors/cookies";
import successLog from "./interceptors/successLog";
import errorLog from "./interceptors/errorLog";

type Config = {
  baseUrl: string,
  headers?: { [string]: string },
  auth?: {
    username: string,
    password: string
  },
  httpsAgent?: any,
  errorReporter?: (any) => void,
  requestInterceptor?: () => void
};

const getApiClient = (config: Config, req: any, res: any) => {
  const {
    baseUrl,
    headers,
    auth,
    httpsAgent,
    errorReporter,
    requestInterceptor
  } = config;

  const instance = axios.create({
    auth,
    httpsAgent,
    baseURL: `${baseUrl}/api`,
    headers: {
      "jp-api-key": process.env.JP_API_KEY || "",
      "X-JP-Device": process.env.JP_API_DEVICE || "",
      ...headers
    },
    responseType: "json",
    transformResponse: [
      (data) => {
        if (typeof data === "string") {
          return data.length === 0 ? {} : JSON.parse(data);
        }

        return data;
      },
      (data) => {
        if (!data) {
          return data;
        }

        return toCamelCase(data);
      }
    ],
    withCredentials: true
  });

  if (requestInterceptor) {
    instance.interceptors.request.use(requestInterceptor);
  }

  if (res) {
    instance.interceptors.response.use(setResponseCookies(res));
  }

  instance.interceptors.response.use(successLog, errorLog(errorReporter));

  return (apiRequest) => apiRequest(instance);
};

export default getApiClient;
